import { Button } from '@mui/material';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useOutletContext } from 'react-router-dom';
import Comment from '../../components/comments/Comment';
import DrawerModal from '../../components/Drawer/Drawer';
// import DraggableModal from '../../components/Modal/DraggableModal';
import CustomModal from '../../components/Modal/CustomModal';
import { fetchCommentsApi } from '../../components/Utilities/apis/commentsApis';
import pbiMark from '../../components/Utilities/pbiTiming';
import {
  addAllPages,
  addCommentsToReports,
  addCurrentPageName,
  addReportSlice,
  addVisualPageName,
  setisReportLoaded,
} from '../../redux/userReducer';
import RevenuDataComponent from '../RevenueDataModal/RevenuDataModal';
import classes from './floatDivStyles.module.css';
import './PowerBiReport.css';
import PrintReportBI from './PrintReport';

// The Power BI SDK posts '/report/load' to its iframe without catching the
// result. If that load is cancelled (e.g. the report is closed before it
// finishes) the rejection is a plain { message, detailedMessage } object, which
// React's dev overlay shows as "Uncaught runtime errors [object Object]".
// Only rejections of that exact shape are handled; anything else still
// surfaces normally. Registered once for the whole app (several report
// instances can be mounted at the same time).
if (typeof window !== 'undefined' && !window.__onedataPbiRejectionGuard) {
  window.__onedataPbiRejectionGuard = true;
  // The SDK also answers messages from a report iframe that has just been
  // removed (report closed / replaced, "view as" switched): its window is then
  // null and the reply throws "Cannot read properties of null (reading
  // 'postMessage')" inside WindowPostMessageProxy. Harmless: nothing is left to
  // receive the reply. Only that exact error from the proxy is swallowed.
  const isDetachedFrameReply = (err) =>
    err instanceof TypeError &&
    /reading 'postMessage'/.test(err.message || '') &&
    /WindowPostMessageProxy/.test(err.stack || '');
  window.addEventListener('error', (event) => {
    if (isDetachedFrameReply(event?.error)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      console.warn('Power BI reply to a removed report frame ignored');
    }
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    if (isDetachedFrameReply(reason)) {
      event.preventDefault();
      console.warn('Power BI reply to a removed report frame ignored');
      return;
    }
    if (
      reason &&
      typeof reason === 'object' &&
      !(reason instanceof Error) &&
      typeof reason.message === 'string' &&
      'detailedMessage' in reason
    ) {
      event.preventDefault();
      console.warn('Power BI embed request cancelled:', reason.message);
    }
  });
}

const PowerBIReport = (props) => {
  //code to Zoom the report , will set if needed
  // let currentZoom = await window.Report.getZoom();
  // await window.Report.setZoom(1);
  // zoomLevel: 2,
  const navigate = useNavigate(); // <-- useNavigate hook for navigation

  const googleIdToken = useOutletContext(); // <-- access context value
  const reportRef = useRef(null);
  const {
    selectedReport,
    embedUrl,
    embedToken,
    handleEmbedError,
    isActive = true,
    // isVisible: shown on screen. Normally the same as isActive; the warm spare
    // is shown (without being "active") while the first report is on its way,
    // so Power BI's own loading screen appears straight away.
    isVisible = isActive,
    onRendered,
    // onStatusChange(reportId, status | null): background loading status for
    // the header indicator ('loading' | 'ready' | 'slow' | 'error').
    onStatusChange,
  } = props;
  const [openEditIcons, setOpenEditIcons] = useState(false);
  const [open, setOpen] = useState(false);
  const [openComments, setOpenComments] = useState(false);
  const dispatch = useDispatch();
  const allSliceData = useSelector((state) => state.PowerBi.reportSliceState);
  const isReportLoaded = useSelector((state) => state.PowerBi.isReportLoaded);
  const rawComments = useSelector((state) => state.PowerBi.commentsOfReports);
  const comments = Array.isArray(rawComments) ? rawComments : [];
  const currentPage = useSelector((state) => state.PowerBi.currentPage);
  const visualPageName = useSelector((state) => state.PowerBi.visualPageName);
  console.log('visualPageName', visualPageName);
  let user = useSelector((state) => state.PowerBi.user);

  // Assuming 'comments' is the array you provided (e.g., const comments = [...])
  // And 'currentPage' is the string variable you want to match against (e.g., 'Progress towards target')
  // console.log(comments);

  const getNormalizedVisualPageName = (visualPageName = '') => {
    if (!visualPageName) return '';

    let name = visualPageName.trim();

    // Exact mappings first
    if (name === 'Inv and Allocated Cost') {
      return 'Investment and Allocated cost';
    }

    if (name === 'Revenue and FTE') {
      name = name.replace('and', '&');
    }

    if (name === 'Offshore Pyramid') {
      return 'Offshore Pyramid – Billed + investment + Allocated FTE';
    }

    let suffix = '';

    // Increases / Declines
    if (name.includes('(Inc)')) {
      name = name.replace('(Inc)', '').trim();
      suffix += ' increases';
    } else if (name.includes('(Dec)')) {
      name = name.replace('(Dec)', '').trim();
      suffix += ' declines';
    }

    // Period / Location suffixes
    if (name.includes('(Month)')) {
      name = name.replace('(Month)', '').trim();
      suffix += '-Monthly';
    }

    if (name.includes('(Qtr)')) {
      name = name.replace('(Qtr)', '').trim();
      suffix += '-Quarterly';
    }
    if (name.includes('(Offshore)')) {
      name = name.replace('(Offshore)', '').trim();
      suffix += '-offshore';
    }

    if (name.includes('(Onsite)')) {
      name = name.replace('(Onsite)', '').trim();
      suffix += '-onsite';
    }

    return `${name}${suffix}`;
  };

  const normalizedVisualPageName = getNormalizedVisualPageName(visualPageName);
  console.log('normalizedVisualPageName', normalizedVisualPageName);

  let CurrentPageComments = comments?.filter(
    (comment) =>
      comment?.WEB_REPORT?.trim().toLowerCase() ===
      normalizedVisualPageName.trim().toLowerCase(),
  );
  console.log('CurrentPageComments', CurrentPageComments);

  const handleEditButtons = () => {
    setOpenEditIcons(!openEditIcons);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDossierCorrection = () => {
    setOpen(true);
  };
  // isActive: this is the report on screen. Other instances are kept-alive
  // reports or the warm spare; they stay mounted but hidden and must not touch
  // shared Redux state, window.Report or the page's buttons and modals.
  const isActiveRef = useRef(isActive);
  isActiveRef.current = isActive;
  const onRenderedRef = useRef(onRendered);
  onRenderedRef.current = onRendered;
  const onStatusChangeRef = useRef(onStatusChange);
  onStatusChangeRef.current = onStatusChange;

  useEffect(() => {
    if (
      isActive &&
      selectedReport?.ReportName?.trim() === 'Financial Performance' &&
      isReportLoaded
    ) {
      fetchCommentsApi({ googleIdToken }).then((result) =>
        dispatch(addCommentsToReports(result)),
      );
    }
  }, [
    dispatch,
    googleIdToken,
    isActive,
    isReportLoaded,
    selectedReport?.PBIREPORTID,
    selectedReport?.ReportName,
  ]);

  // Latest error callback, read from the memoized handlers without making
  // them change every render.
  const handleEmbedErrorRef = useRef(handleEmbedError);
  handleEmbedErrorRef.current = handleEmbedError;

  const reportId = selectedReport?.PBIREPORTID;
  const reportSlicers = allSliceData[reportId];

  useEffect(() => {
    if (embedUrl && embedToken && isActiveRef.current) pbiMark('embed started');
  }, [embedUrl, embedToken, reportId]);

  // The report object embedded by *this* component instance. Handlers read it
  // instead of window.Report so that a handler still running for a report the
  // user has just left can't write that report's state under the new report.
  const embeddedReportRef = useRef(null);
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // hasRenderedRef: the report has fully rendered once (used to restore its
  // state when it becomes visible again, and to trigger the next spare).
  const hasRenderedRef = useRef(false);

  // --- Load status for the header indicator ---
  const SLOW_AFTER_MS = 60 * 1000;
  const slowTimerRef = useRef(null);
  const reportIdRef = useRef(reportId);
  reportIdRef.current = reportId;
  const setStatus = (status) => {
    if (reportIdRef.current) onStatusChangeRef.current?.(reportIdRef.current, status);
  };
  const clearSlowTimer = () => {
    if (slowTimerRef.current) {
      clearTimeout(slowTimerRef.current);
      slowTimerRef.current = null;
    }
  };
  // Embedding starts once the report has a URL and token. (A later token
  // refresh doesn't count as a new load.)
  useEffect(() => {
    if (!reportId || !embedUrl || !embedToken || hasRenderedRef.current) return;
    setStatus('loading');
    clearSlowTimer();
    // If Power BI never reports 'rendered' (e.g. a visual keeps loading), mark
    // it so the background queue moves on to the next report.
    slowTimerRef.current = setTimeout(() => {
      slowTimerRef.current = null;
      if (!hasRenderedRef.current) setStatus('slow');
    }, SLOW_AFTER_MS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportId, Boolean(embedUrl && embedToken)]);
  useEffect(
    () => () => {
      clearSlowTimer();
      setStatus(null); // iframe removed: no longer loaded
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  // True while this instance is mounted, still showing `report`, and visible.
  const canUpdateSharedState = (report) =>
    isMountedRef.current &&
    isActiveRef.current &&
    report &&
    embeddedReportRef.current === report;

  // Copies this report's pages, active page and slicer state into Redux.
  // Runs after each render of the visible report, and when a kept report
  // becomes visible again (so Redux describes the report on screen).
  const syncReportState = useCallback(
    async (report) => {
      try {
        const pages = await report.getPages();
        if (!canUpdateSharedState(report)) return;
        dispatch(
          addAllPages(
            pages.map((page) => ({
              name: page.name,
              displayName: page.displayName,
            })),
          ),
        );
        // Retrieve the active page.
        const page = pages.filter((p) => p.isActive)[0];
        if (!page) return;
        const visuals = await page.getVisuals();
        const visualPageName = visuals?.[0]?.page?.displayName || '';
        // Retrieve the target visual.
        const slicerS = visuals.filter((visual) => visual.type === 'slicer');
        const allSlicesReport = await Promise.all(
          slicerS.map(async (slicer) => {
            const s = await slicer.getSlicerState();
            return [s.filters, slicer.name];
          }),
        );
        if (!canUpdateSharedState(report)) return;
        dispatch(
          addReportSlice([
            allSlicesReport.filter((item) => item[0].length > 0),
            report.config.id,
            page.displayName,
          ]),
        );
        dispatch(addVisualPageName(visualPageName));
        dispatch(addCurrentPageName(page?.displayName));
        dispatch(setisReportLoaded(true));
      } catch (err) {
        // Usually the report was switched or closed mid-way.
        if (canUpdateSharedState(report)) {
          console.error('Error reading report state:', err);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );

  // Becoming the visible report: point window.Report at it and refresh the
  // shared Redux state from it (or mark "not loaded" if it is still loading).
  useEffect(() => {
    if (!isActive) return;
    const report = embeddedReportRef.current;
    if (report) window.Report = report;
    if (report && hasRenderedRef.current) {
      syncReportState(report);
    } else {
      dispatch(setisReportLoaded(false));
    }
  }, [isActive, dispatch, syncReportState]);

  // Memoized so PowerBIEmbed doesn't get a new config object on every render.
  const embedConfig = useMemo(
    () => ({
      type: 'report', // Supported types: report, dashboard, tile, visual and qna
      id: reportId,
      pageName: 'TA_OneData_PBI_Embed',
      embedUrl: embedUrl,
      accessToken: embedToken,
      tokenType: models.TokenType.Embed,
      slicers: reportSlicers,
      settings: {
        panes: {
          filters: {
            visible: false,
          },
          pageNavigation: {
            visible: false,
          },
        },
        filterPaneEnabled: false,
        navContentPaneEnabled: true,
        background: 0,
      },
    }),
    [reportId, embedUrl, embedToken, reportSlicers],
  );

  // Memoized so the event handlers aren't re-registered on every render.
  const eventHandlers = useMemo(
    () =>
      new Map([
        [
          'loaded',
          function () {
            if (!isActiveRef.current) return;
            pbiMark('report loaded');
            dispatch(setisReportLoaded(false));
          },
        ],
        [
          'rendered',
          function () {
            const report = embeddedReportRef.current;
            if (!hasRenderedRef.current) {
              hasRenderedRef.current = true;
              clearSlowTimer();
              setStatus('ready');
              if (isActiveRef.current) pbiMark('report rendered');
              // Let the parent prepare the next warm spare iframe now that the
              // report the user is waiting for is done.
              onRenderedRef.current?.();
            }
            if (isActiveRef.current && report) syncReportState(report);
          },
        ],
        [
          'error',
          function (event) {
            const errorCode = event?.detail?.errorCode;
            if (!hasRenderedRef.current && event?.detail?.level === models.TraceType.Fatal) {
              clearSlowTimer();
              setStatus('error');
            }
            if (errorCode == 401 || errorCode == 403) {
              handleEmbedErrorRef.current?.();
            }
          },
        ],
      ]),
    [dispatch, syncReportState],
  );

  // Reports loading or kept in the background, and the spare, are stacked
  // UNDER the visible report at the same size and position. They stay
  // "visible" to the browser (not visibility:hidden / display:none) because
  // browsers pause drawing in hidden cross-origin iframes, which would stop
  // background reports from rendering. The visible report sits on top with a
  // white background, and the ones underneath can't be clicked or focused.
  const containerStyle = isVisible
    ? { display: 'flex', position: 'relative', zIndex: 1, background: '#ffffff' }
    : {
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 0,
        // Transparent, so nothing underneath ever shows through (e.g. while no
        // report is visible). Unlike visibility:hidden, opacity doesn't make
        // the browser pause drawing inside the iframe.
        opacity: 0,
        pointerEvents: 'none',
      };

  return (
    <div
      style={containerStyle}
      aria-hidden={!isVisible}
      // inert: keyboard focus and clicks can't reach reports underneath.
      {...(!isVisible ? { inert: '' } : {})}
    >
      <div style={{ flex: 1 }}>
        <PowerBIEmbed
          ref={reportRef}
          cssClassName={'PowerBiReport'}
          embedConfig={embedConfig}
          eventHandlers={eventHandlers}
          getEmbeddedComponent={(embeddedReport) => {
            embeddedReportRef.current = embeddedReport;
            if (isActiveRef.current) window.Report = embeddedReport;
          }}
        />
      </div>
      {isActive && (
        <>
          <DrawerModal
            open={openComments}
            handleClose={() => {
              setOpenComments(!openComments);
            }}
          >
            <Comment commentData={CurrentPageComments?.[0]} />
          </DrawerModal>

          {user?.ISADMIN &&
            selectedReport?.ReportName?.trim() === 'Financial Performance' && (
              <Button
                className={classes.floatDiv}
                size='small'
                variant='contained'
                onClick={() => setOpenComments((prev) => !prev)}
                sx={{
                  textTransform: 'none',
                  fontSize: '0.75rem', // smaller text
                  fontWeight: 600,
                  borderRadius: 999,
                  px: 1.75,
                  py: 0.4,
                  minHeight: 28,
                  backgroundColor: '#f3f4f6', // light background
                  color: '#382c2c', // dark text for contrast
                  boxShadow: '0 3px 8px rgba(0,0,0,0.15)',
                  '&:hover': {
                    backgroundColor: '#e5e7eb',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                  },
                }}
              >
                Add Comments
              </Button>
            )}

          <CustomModal
            open={open}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <>
              <RevenuDataComponent handleClose={handleClose} />
            </>
          </CustomModal>

          {/* ref is pointing to the report to print */}
          {selectedReport?.ReportName === 'PMS Completion Status' && (
            <PrintReportBI ref={reportRef} />
          )}
        </>
      )}
    </div>
  );
};

export default PowerBIReport;
